import React from 'react'
import AdviserProfileLanguagePreferences from '../../../common/AdviserProfiles/AdviserProfileLanguagePreferences'
import * as styles from './_AdviserProfileLanguagePreferencesEditor.scss'
import { connect } from 'react-redux'
import { FormCheck } from 'react-bootstrap'
import { actions } from './adviserProfileLanguagePreferencesEditorActions'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types';

class adviserProfileLanguagePreferencesEditorActions extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    editingLanguages: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    startEditingLanguages: PropTypes.func.isRequired,
    stopEditingLanguages: PropTypes.func.isRequired,
    cancelEditingLanguages: PropTypes.func.isRequired,
    fetchLanguages: PropTypes.func.isRequired,
    allLanguages: PropTypes.array.isRequired,
    languageSelectedChanged: PropTypes.func.isRequired,
    formIsValid: PropTypes.bool.isRequired,
    validationstate: PropTypes.object.isRequired,
    submitting: PropTypes.bool.isRequired
  };

  constructor (props) {
    super(props)
    this.stopEditingLanguagePreferences = this.stopEditingLanguagePreferences.bind(this)
  }

  componentDidMount () {
    this.props.fetchLanguages()
  }

  stopEditingLanguagePreferences () {
    this.props.stopEditingLanguages()
  }

  render () {
    const profile = this.props.profile
    const editingLanguages = this.props.editingLanguages
    const submitting = this.props.submitting
    const selectedLanguages = this.props.profile.languagePreferences || []

    if (editingLanguages || submitting) {
      const allLanguages = this.props.allLanguages.map(language => ({ ...language }))
      allLanguages.forEach((language) => {
        var selected = false
        selectedLanguages.forEach((selectedLanguage) => {
          selected = selected || selectedLanguage.languageId === language.languageId
        })
        language.selected = selected
      })

      return <div>
        <h4 className={styles['title']}>Languages</h4>
        <form className={styles['form-bottom-margin']}>
          {allLanguages.map((language) => {
            return <FormCheck
              key={language.languageId}
              type="checkbox"
              checked={language.selected}
              value={language.languageId}
              onChange={() => {
                this.props.languageSelectedChanged(language)
              }}
              label={language.language}
            />

          })}
        </form>
      </div>
    }

    return <AdviserProfileLanguagePreferences languages={profile.languagePreferences || []} />
  }
}

const mapStateToProps = (state) => {

  return {
    editingLanguages: state.adviserProfileEditorContainer.languagePreferences.editingLanguages || false,
    loading: state.adviserProfileEditorContainer.languagePreferences.loadingLanguages || false,
    formIsValid: state.adviserProfileEditorContainer.languagePreferences.languagePreferences.isInvalid.formIsValid || false,
    validationstate: state.adviserProfileEditorContainer.languagePreferences.languagePreferences.isInvalid || {},
    submitting: state.adviserProfileEditorContainer.languagePreferences.submitting || false,
    allLanguages: state.adviserProfileEditorContainer.languagePreferences.allLanguages || []
  }
}

const mapDispatchToProps = (dispatch) => {
  const { edit, fetch, set } = actions
  return bindActionCreators({
    startEditingLanguages: edit.start,
    stopEditingLanguages: edit.stop,
    cancelEditingLanguages: edit.cancel,
    fetchLanguages: fetch.languages,
    languageSelectedChanged: set.selectionChanged
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (adviserProfileLanguagePreferencesEditorActions))
